/**
 * Dev-only logger. Keeps diagnostic output out of production bundles so we
 * never leak internal state or request details to end users' consoles.
 */
const isDev = process.env.NODE_ENV !== 'production';

export const log = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
};

export default log;
